import type { UseFormReturn } from "react-hook-form"
import { FormField } from "../ui-form/form-field"
import { TravelBookingFormValues } from "../lib/schemas/travel-booking"
import { renderField } from "../lib/FormConfigs/Renderer"
import { FieldConfig } from "../lib/FormConfigs/config"

interface DestinationStepProps {
  form: UseFormReturn<TravelBookingFormValues>
  config?: FieldConfig[]
}

export function DestinationStep({ form, config }: DestinationStepProps) {
  return (
    <div className="max-w-sm">
      <div className="grid grid-cols-[auto_1fr] gap-x-[18.5px]">
        {config?.map((field, index) => {
          const isCompleted = form.watch(field.name as keyof TravelBookingFormValues)
          const isLast = index === config.length - 1

          return (
            <>
              {/* Step indicator column */}
              <div key={`indicator-${field.name}`} className="flex flex-col items-center justify-start">
                {/* Circle indicator */}
                <div
                  className={`
                    w-[9px] h-[9px] rounded-full border mt-1.5 flex-shrink-0
                    transition-colors duration-300
                    ${isCompleted ? "bg-blue-700 border-blue-700" : "bg-white-A700 border-blue-700"}
                  `}
                />
                
                {/* Dotted line (except for last item) */}
                {!isLast && (
                  <div className={`w-0.5 flex-1 border-l-2 border-dotted min-h-[1.5rem] ${isCompleted ? 'border-blue-700 ' : 'border-gray-300 '}`} />
                )}
              </div>

              {/* Form field column */}
              <div key={`field-${field.name}`} className="pb-6">
                <FormField
                  form={form}
                  name={field.name as keyof TravelBookingFormValues}
                  label={field.label}
                  render={({ field: formField }) => {
                    return renderField(field, formField)
                  }}
                />
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}